angular.module("iFAST.service")
    .factory("modalSvc", ["$uibModal", function($modal) {
        "use strict";

        var CANCEL = "cancel",
            MODAL_CONTAINER = "modalContainer",
            SKIP_TWO = 2;

        /**
         * @name genericController
         * @description create a modal generic controller that dynamically builds it's dependencies.
         * Example result will look like:
         * [ "$scope", "$uibModalInstance", "objectId", "advisorReportsController", function modalContainer ($scope,$modalInstance, objectId, advisorReportsController) {
                            $scope.modalContainer = this;

                            this.closeModal = function () {
                                $modalInstance.dismiss("cancel");
                            };
                            this.objectId = objectId;
                            this.advisorReportsController = advisorReportsController;
                        }]
         *
         * @param modalConfig
         * @returns {string[]}
         */
        var genericController = function (modalConfig) {
            var dependency = ["$scope","$uibModalInstance"]; //required dependencies

            angular.forEach(modalConfig.resolve, function (value, key){
                this.push(key);
            }, dependency)

            var modalController = function ($scope,$modalInstance){
                $scope[modalConfig.controllerAs] = this;

                this.closeModal = function () {
                    $modalInstance.dismiss(CANCEL);
                }

                var i = SKIP_TWO;
                for (i;i<arguments.length;i=i+1){
                    this[dependency[i]] = arguments[i];
                }
            }

            dependency.push(modalController);
            return dependency;
        }

        var modalInstanceList = {},
            index = 0,
            open = function (modalConfig) {
                var key = index + "",
                    modalInstance;

                index++;    //increment index
                modalConfig.controllerAs = modalConfig.controllerAs || MODAL_CONTAINER
                modalConfig.controller = genericController(modalConfig);


                modalInstance = $modal.open(modalConfig);
                modalInstanceList[key] = modalInstance;

                modalInstance.result.then(function () {
                    // modal instance closed
                    delete modalInstanceList[key];
                }, function () {
                    //resolved...
                    delete modalInstanceList[key];
                });

                return modalInstance;
            },
            get = function (key){
                if (key){
                    return modalInstanceList[key];
                }
                return null;
            },
            closeAll = function(reason) {
                angular.forEach(modalInstanceList, function(modal){
                    modal.dismiss(reason || CANCEL);
                });

                modalInstanceList = {};     // remove all modal instances from list
            };

        return {
            open: open,
            closeAll: closeAll
        };

    }]);


// WEBPACK FOOTER //
// ./WebContent/src/_common/services/shared/modal-service.js